import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LabelContainer from './LabelContainer';
import ErrorMessage from './ErrorMessage';

import './BoxInput.scss';

const BoxInput = ({
	type = 'radio',
	input,
	label,
	testId = null,
	addFocusHandler,
	className,
	meta = {},
	id,
	autoFocus,
	showAditionalElement,
}) => {
	const showError = meta?.error && meta?.touched && typeof meta.error === 'object';

	return (
		<div className={cx('onboarding-box', { [className]: !!className, error: showError })}>
			<input
				className="onboarding-box__input"
				name="radio"
				data-test={testId}
				type={type}
				id={id}
				autoFocus={autoFocus}
				{...input}
			/>

			<LabelContainer
				id={id}
				label={label}
				showAditionalElement={showAditionalElement}
				addFocusHandler={addFocusHandler}
			/>

			{showError && <ErrorMessage error={meta.error} testId={testId ? `${testId}-error` : null} />}
		</div>
	);
};

BoxInput.propTypes = {
	input: PropTypes.shape({
		value: PropTypes.string.isRequired | PropTypes.bool.isRequired,
	}),
	type: PropTypes.string,
	className: PropTypes.string,
	label: PropTypes.string,
	testId: PropTypes.string,
	id: PropTypes.string.isRequired,
	addFocusHandler: PropTypes.bool,
	showAditionalElement: PropTypes.node,
};

BoxInput.defaultProps = {
	type: 'radio',
	testId: null,
	showAditionalElement: null,
};

export default BoxInput;
